<template>
    <div class="form-group">
        <label class="label">Harbor Maintenance Fee</label>
        <div class="col-12 row p-0">
            <div class="col-6 p-0">
                <app-input 
                    type="text"
                    v-model="displayData"
                    :placeholder="'Data'"
                    :required="true"
                    :disabled="is_view"
                    @blur="rawInputData = ''" 
                />
            </div>
            <div class="col-6 p-0">
                <app-input 
                    type="text"
                    v-model="displayValue"
                    :placeholder="'Value'"
                    :required="true"
                    :disabled="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BankCharges',
    props: {
        value: {
            type: Object,
            default: () => ({
                data: '',
                value: ''
            })
        },
        is_view : {
            type : Boolean,
            default : false,
        }
    },
    data() {
        return {
            rawInputData: '',  
            isTypingDotData: false,
            internalValue: { ...this.value }
        };
    },
    watch: {
        // Escucha cambios en el objeto que viene del Padre
        value: {
            handler(newValue) {
                this.internalValue = { ...newValue };
            },
            deep: true
        },
        // NUEVO: Escucha cambios en el Data interno y avisa al Padre
        'internalValue.data': function(nuevoData) {
            this.updateValue(); 
        }
    },
    computed: {
        displayValue: {
            get() {
                const val = this.internalValue.value;
                if (val === null || val === undefined || val === '') return '$ 0.000';
                
                // Usamos Intl.NumberFormat para manejar millones y decimales
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 3,
                    maximumFractionDigits: 3
                }).format(val);
            },
            set(newValue) {
                let cleanValue = String(newValue).replace(/[^0-9.]/g, '');
                let numericValue = parseFloat(cleanValue);
                this.internalValue.value = isNaN(numericValue) ? 0 : numericValue;
                this.updateValue();
            }
        },
        displayData: {
            get() {
                const val = this.internalValue.data;
                if (val === null || val === '') return this.rawInputData || '$ 0';

                // Si el usuario está escribiendo, mostramos el raw
                if (this.rawInputData !== '') return '$ ' + this.rawInputData;

                return '$ ' + new Intl.NumberFormat('en-US').format(val);
            },
            set(newValue) {
                const cleanValue = newValue.replace(/[^0-9.]/g, '');
                this.rawInputData = cleanValue;  // guardamos el string tal cual

                if (cleanValue.endsWith('.')) {
                    this.isTypingDotData = true;
                    return;
                }

                this.isTypingDotData = false;

                const numericValue = cleanValue === '' ? null : parseFloat(cleanValue);   
                if (!isNaN(numericValue) || cleanValue === '') {
                    this.internalValue.data = numericValue;
                    this.updateValue();
                }
            }
        },
    },
    methods: {
        updateValue() {
            this.$emit('input', { 
                data: this.internalValue.data, 
                value: this.internalValue.value 
            });
        }
    }
}
</script>

<style scoped>
    .label {
        font-weight: 600;
    }
    .row {
        margin-left: 0;
        margin-right: 0;
    }
</style>